import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../App';

function Home() {
  const { t, linkPrefix } = useLanguage();

  const features = [
    { icon: '👨‍🍳', ...t.features.feature1 },
    { icon: '🔍', ...t.features.feature2 },
    { icon: '⚡', ...t.features.feature3 },
    { icon: '📝', ...t.features.feature4 },
    { icon: '🌍', ...t.features.feature5 },
    { icon: '💡', ...t.features.feature6 },
  ];

  const foodEmojis = [
    { emoji: '🍝', name: 'Pasta' },
    { emoji: '🍲', name: 'Soup' },
    { emoji: '🍳', name: 'Breakfast' },
    { emoji: '🥗', name: 'Salad' },
  ];

  return (
    <main>
      <Helmet>
        <title>Chefyz - {t.hero.title}</title>
        <meta name="description" content={t.hero.subtitle} />
        <meta property="og:title" content={`Chefyz - ${t.hero.title}`} />
        <meta property="og:description" content={t.hero.subtitle} />
      </Helmet>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>{t.hero.title}</h1>
              <p>{t.hero.subtitle}</p>
              <div className="hero-buttons">
                <a href="https://apps.apple.com/tr/app/chefyz/id6757770703" className="badge-btn" target="_blank" rel="noopener noreferrer" data-testid="appstore-hero-btn">
                  <span className="badge-apple-logo" aria-hidden="true"></span>
                  <div className="badge-btn-text">
                    <span>Download on the</span>
                    <strong>App Store</strong>
                  </div>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.buse59299.chefyz" className="badge-btn" target="_blank" rel="noopener noreferrer" data-testid="playstore-hero-btn">
                  <span className="badge-play-logo" aria-hidden="true">▶</span>
                  <div className="badge-btn-text">
                    <span>Get it on</span>
                    <strong>Google Play</strong>
                  </div>
                </a>
                <Link to={`${linkPrefix}/support`} className="btn btn-secondary">
                  {t.hero.learnMore}
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <div className="hero-food-images">
                {foodEmojis.map((item, index) => (
                  <div key={index} className="hero-food-card">
                    <span>{item.emoji}</span>
                    <p>{item.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="section-header">
            <h2>{t.features.title}</h2>
            <p>{t.features.subtitle}</p>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card" data-testid={`feature-card-${index}`}>
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>{t.cta.title}</h2>
            <p>{t.cta.subtitle}</p>
            <div className="store-buttons">
              <a href="https://apps.apple.com/tr/app/chefyz/id6757770703" className="badge-btn badge-btn-light" target="_blank" rel="noopener noreferrer" data-testid="appstore-btn">
                <span className="badge-apple-logo" aria-hidden="true"></span>
                <div className="badge-btn-text">
                  <span>Download on the</span>
                  <strong>App Store</strong>
                </div>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.buse59299.chefyz" className="badge-btn badge-btn-light" target="_blank" rel="noopener noreferrer" data-testid="playstore-btn">
                <span className="badge-play-logo" aria-hidden="true">▶</span>
                <div className="badge-btn-text">
                  <span>Get it on</span>
                  <strong>Google Play</strong>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
